// extracted by mini-css-extract-plugin
module.exports = {"faqLayout":"Faq-module--faqLayout--2HU22","faqContent":"Faq-module--faqContent--1EsvK","introText":"Faq-module--introText--1ODE8","lastBreak":"Faq-module--lastBreak--2RuZx"};